import React, { PureComponent } from 'react'
import { AutoSuggestField } from 'components'
import PropTypes from 'prop-types'

export class CountrySelect extends PureComponent {
  static propTypes = {
    countries: PropTypes.array.isRequired,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    onChange: PropTypes.func,
    label: PropTypes.string,
  }

  labelProvider = id => {
    return (id && this.props.countries && (this.props.countries.find(c => `${c.id}` === `${id}`) || {}).name) || ''
  }

  suggestionProvider = async(text) => {
    return (this.props.countries || []).filter(c => c.name.toLowerCase().startsWith(`${text}`.toLowerCase())).map(c => c.id)
  }

  render = () => {
    let {label, onChange, value, ...props} = this.props
    return (
      <AutoSuggestField
        {...props}
        label={label}
        value={value}
        onChange={onChange}
        labelProvider = {this.labelProvider}
        suggestionProvider={this.suggestionProvider}
      />
    )
  }
}